import { IWeekAheadRelease } from '@/types'
import Image from 'next/image'

import { getImageUrl } from 'utils/image'
import { MarkdownContent } from '../MarkdownContent'

export const ReleaseCard = ({ image, text }: Omit<IWeekAheadRelease, 'id'>) => {
  return (
    <div className='relative flex flex-col-reverse items-center justify-between gap-6 bg-cool-50 px-8 py-6 text-center xs:rounded-lg sm:flex-row sm:gap-12 sm:text-left'>
      <div>
        <MarkdownContent>{text}</MarkdownContent>
      </div>

      <div className='relative flex h-[180px] w-full max-w-[240px] items-center drop-shadow-[0_4px_5px_rgba(38,35,56,0.15)]'>
        <Image
          src={getImageUrl(image.data, 'medium')}
          alt={image.data.attributes.alternativeText || 'Release Image'}
          className='object-contain'
          fill={true}
          quality={75}
        />
      </div>
    </div>
  )
}
